import { OrderDetails } from '@nemuru-eng/js-api-client';

import { OrderAction } from '../../../../types/OrderAction';
import { getCaptureActions } from './utils/getCaptureActions';
import { getOrderCreationAction } from './utils/getOrderCreationAction';
import { getOrderRefunds } from './utils/getOrderRefunds';
import { getPayoutActions } from './utils/getPayoutActions';

export const getOrderActions = (orderDetails: OrderDetails): OrderAction[] => {
  const orderCreation = getOrderCreationAction(orderDetails);
  const actions: OrderAction[] = [orderCreation];

  const refundActions = getOrderRefunds(orderDetails);
  actions.push(...refundActions);

  const captureActions = getCaptureActions(orderDetails);
  actions.push(...captureActions);

  const payoutActions = getPayoutActions(orderDetails, actions);
  actions.push(...payoutActions);

  return actions.sort((a, b) => (a.createdAt < b.createdAt ? -1 : 1));
};
